export default __webpack_public_path__ + "static/djbilallogowhite-56cab815c87892be5b6b677494143d04.jpg";